import { render } from "./HelloWorld.vue?vue&type=template&id=12bf03ba&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=12bf03ba&scoped=true&lang=css"

import exportComponent from "D:\\Users\\Igory\\Desktop\\my_first_vue.js_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12bf03ba"]])

export default __exports__